import * as React from 'react';

export const VillageIcon = () => (
  // oxlint-disable-next-line react/forbid-elements
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
    <path
      fill="#C9C9C9"
      fillRule="evenodd"
      d="M9.059 13h1.647c.494 0 .823-.325.823-.813V6.5h.824c.247 0 .494-.081.659-.244.33-.325.247-.812-.083-1.137L7.165.244a.875.875 0 0 0-1.07 0L.328 5.119C0 5.444-.082 5.93.247 6.256c.082.163.33.244.577.244h.823v5.688c0 .487.33.812.824.812h1.647c.494 0 .823-.325.823-.813V9.75h3.294v2.438c0 .487.33.812.824.812z"
    />
  </svg>
);
